import { render, staticRenderFns } from "./JobEditExaminationApprovalCreate.vue?vue&type=template&id=0973e51e"
import script from "./JobEditExaminationApprovalCreate.vue?vue&type=script&lang=js"
export * from "./JobEditExaminationApprovalCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports